import axios from "axios";
import { Buffer } from "buffer";
import parser from "content-disposition-parser";
import saveAs from "file-saver";
import { createAxios, getErrorMessage } from "./axios";

export function download(name: string, data: string, type: string) {
    const uint8Array = Uint8Array.from(Buffer.from(data, "base64"));
    var blob = new Blob([uint8Array], { type: type });
    let objectURL = window.URL.createObjectURL(blob);
    let anchor = document.createElement('a');

    anchor.href = objectURL;
    anchor.download = name;
    anchor.click();

    URL.revokeObjectURL(objectURL);
}

export function arrayBufferToBase64(buffer: ArrayBuffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

export async function downloadFromApi(path: string) {
    const result = await createAxios().get<Blob>(path, { responseType: "blob" });
    const cd = result.headers["content-disposition"];
    const fileName = cd == null ? undefined : parser(cd).filename as string;
    saveAs(result.data, fileName);
}

export async function downloadFromApiPost(path: string, data: any) {
    try {
        const result = await createAxios().post<Blob>(path, data, { responseType: "blob" });
        const cd = result.headers["content-disposition"];
        const fileName = cd == null ? undefined : parser(cd).filename as string;
        saveAs(result.data, fileName);
    }
    catch (error) {        
        if (axios.isAxiosError(error)) {
            const errorMsg = await getErrorMessage(error);
            alert(errorMsg);
        }
        else {
            alert(error);
        }
    }
}

export function base64StringFromFileInputChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, callback: (data: string | undefined) => void) {
    var input = event.currentTarget as HTMLInputElement;
    var file = input.files && input.files[0];
    if (file == null) {
        callback(undefined);
        return;
    }
    var reader = new FileReader();
    reader.onload = e => {
        callback(e.target?.result == null ? undefined :
            typeof e.target.result === "string" ? Buffer.from(e.target.result).toString("base64") :
                Buffer.from(e.target.result).toString("base64"));
    };
    reader.onerror = function (e) {
        callback(undefined);
    };
    reader.readAsArrayBuffer(file);
}
